<template>
	<div class="category-management">
		<div class="fx-header">
			<!-- <span>
				<i class="el-icon-arrow-left" @click="goBack"></i>
			</span> -->
			<p class="header-p">店铺级分类</p>
			<div v-if="bigcategoryview !== 0" class="header-btn-box">
				<a @click="importExcel" class="batch-register-btn">
					<i class="excel-icon export-excel-icon"/>
					<span>导入</span>
				</a>

				<a href="javascript:void(0);"  @click="downloadFile(1)" class="batch-register-btn">
					<i class="excel-icon export-excel-icon"/>
					<span>导入模板下载</span>
				</a>
			</div>
			<input type="file" ref="file" id="file" accept=".xls,.xlsx" v-show="false" @change="getFile">
		</div>
		<el-container class="management-container" v-if="bigcategoryview === 0">
			<el-aside class="big-class-wrap" style="width:100%">
				<div class="big-class-header">店铺级大类</div>
				<div class="big-class-btn-box" style="justify-content: space-between;display: flex;">
					<div class="big-class-btn-row1">
						<el-button v-if="AuthorityList['01_0005_0001_00']" size="mini" class="btn-style" @click="addCategory" type="primary" plain>新增</el-button>
						<!-- <el-button v-if="AuthorityList['01_0005_0002_00']" size="mini" class="btn-style" @click="editCategory" type="primary" plain>修改</el-button> -->
						<el-button v-if="AuthorityList['01_0005_0003_00']" size="mini" class="btn-style" @click="tableDeleteMulti" type="primary" plain>删除</el-button>
						<el-button v-if="AuthorityList['01_0005_0013_00']" size="mini" class="btn-style" @click="tableOpen(true)" type="primary" plain>启用</el-button>
						<el-button v-if="AuthorityList['01_0005_0014_00']" size="mini" class="btn-style" @click="tableOpen(false)" type="primary" plain>停用</el-button>
						<!-- <el-button type="primary" size='small' class="fx-big-btn valet-add-btn" @click="importExcel" plain>批量导入商品</el-button> -->

						<a @click="importExcel" class="batch-register-btn">
							<i class="excel-icon export-excel-icon"/>
							<span>导入</span>
						</a>
						<a href="javascript:void(0);" @click="downloadFile(2)" class="batch-register-btn">
							<i class="excel-icon export-excel-icon"/>
							<span>导入模板下载</span>
						</a>
					</div>
					<!-- <div class="big-class-btn-row">
						<el-button v-if="AuthorityList['01_0005_0004_00']" size="mini" class="btn-style" @click="sortCategory" type="primary" plain>排序</el-button>
					</div> -->
					<div class="small-class-search-box">
						<el-input
							placeholder="请输入内容"
							v-model="searchKey"
							clearable
							class="search-input"
							size="mini"
							@keyup.enter.native="bigSearch"></el-input>
						<el-button
							type="primary"
							icon="el-icon-search"
							class="search-btn"
							size="mini"
							@click="bigSearch"></el-button>
					</div>
				</div>
				<div class="big-class-tree-box fx-custom-scroll">
					<el-table class="small-class-table" size='mini' :data="bigClassData" border height="100%" @selection-change="tableSelect">
						<el-table-column type="selection"  align="center" width="55"></el-table-column>
						<el-table-column align="center"
							prop="bc_name"
							label="店铺级大类"
							min-width="150">
						</el-table-column>
						<el-table-column align="center"
							prop="disabledflag"
							label="店铺级大类停用标记"
							min-width="150">
							<template slot-scope="scope">
								<div v-if="!scope.row.disabledflag">启用</div>
								<div v-else>停用</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" min-width="180" class-name="last-colum">
							<template slot-scope="scope">
								<el-button v-if="AuthorityList['01_0005_0002_00']" size="mini" type='text' @click="tableEdit(scope.row)">编辑</el-button>
								<el-button v-if="AuthorityList['01_0005_0003_00']" size="mini" type='text' @click="tableDelete(scope.row)">删除</el-button>
								<el-button v-if="AuthorityList['01_0005_0004_00']" size="mini" type='text' @click="upHandle(scope.$index, scope.row)">上移</el-button>
								<el-button v-if="AuthorityList['01_0005_0004_00']" size="mini" type='text' @click="downHandle(scope.$index, scope.row)">下移</el-button>
								<el-button v-if="AuthorityList['01_0005_0004_00']" size="mini" type='text' @click="topHandle(scope.$index, scope.row)">置顶</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-aside>
		</el-container>
		<el-container class="management-container" v-else>
			<el-aside class="big-class-wrap">
				<div class="big-class-header">店铺级大类</div>
				<div class="big-class-btn-box">
					<div class="big-class-btn-row">
						<el-button v-if="AuthorityList['01_0005_0001_00']" size="mini" class="btn-style" @click="addCategory" type="primary" plain>新增</el-button>
						<el-button v-if="AuthorityList['01_0005_0002_00']" size="mini" class="btn-style" @click="editCategory" type="primary" plain>修改</el-button>
						<el-button v-if="AuthorityList['01_0005_0003_00']" size="mini" class="btn-style" @click="deleteCategory" type="primary" plain>删除</el-button>
					</div>
					<div class="big-class-btn-row">
						<el-button v-if="AuthorityList['01_0005_0013_00']" size="mini" class="btn-style" @click="openCategory(true)" type="primary" plain>启用</el-button>
						<el-button v-if="AuthorityList['01_0005_0014_00']" size="mini" class="btn-style" @click="openCategory(false)" type="primary" plain>停用</el-button>
						<el-button v-if="AuthorityList['01_0005_0004_00']" size="mini" class="btn-style" @click="sortCategory" type="primary" plain>排序</el-button>
					</div>
				</div>
				<div class="big-class-tree-box fx-custom-scroll">
					<el-tree
						ref="bigClassTree"
						:data="classTreeData"
						node-key="id"
						:current-node-key="treeDefaultKey"
						:props="defaultProps"
						:default-expand-all="true"
						:highlight-current="true"
						@node-click="classClickHandle">
						<div class="custom-tree-node" node-key="name" slot-scope='{ node, data }'>
							<!-- <img
								v-if="data.id !== '0'"
								class="category-icon-img"
								:src="bigClassImgUrl(data.shopCategoryImgurl)"
								:onerror="categoryDefaultIcon"> -->
							<span>{{data.bc_name}}</span>
							<span class="class-disabled-icon" v-if="data.disabledflag">停用</span>
							<!-- <span class="class-homepage-icon" v-if="data.showhomepageflag === 0">首页</span> -->
						</div>
					</el-tree>
				</div>
			</el-aside>
			<el-main class="small-class-wrap" style="border:1px solid #eee;padding:0;">
				<SmallClass :AuthorityList='AuthorityList' :templateId="templateId" :smallClassData="selectBigClass" @refreshData="refreshSmallCategory" @onSearch="searchHandle" :smallTableData='smallTableData' :thirdCategoryEnabled='thirdCategoryEnabled'></SmallClass>
			</el-main>
		</el-container>
		<el-dialog title="提示" class="dialog-title" :visible.sync="tipModal" width='400px' :close-on-click-modal="false">
			<div style="padding-bottom:20px;text-align: left;" v-for="item in tipData" :key="item">
				{{item}}
			</div>
		</el-dialog>
		<el-dialog :title="editBigClassTitle" :visible.sync="addCategoryVisible" width="500px" :close-on-click-modal="false">
			<AddBigClass
				:visibleFlag.sync="addCategoryVisible"
				:data="editBigClass"
				:templateId="templateId"
				@refreshData="refreshCategory"></AddBigClass>
		</el-dialog>
		<el-dialog title="店铺级大类排序" :visible.sync="sortCategoryVisible" width="800px" custom-class="sort-class-dialog" :close-on-click-modal="false">
			<SortBigClass
				:visibleFlag.sync="sortCategoryVisible"
				:data="sortClassData"
				@refreshData="refreshCategory"></SortBigClass>
		</el-dialog>
	</div>
</template>

<script>
import SmallClass from '@/components/categoryManagement/SmallClass.vue'
import AddBigClass from '@/components/categoryManagement/AddBigClass.vue'
import SortBigClass from '@/components/categoryManagement/SortBigClass.vue'
const QURL = 'https://fxscms.oss-cn-beijing.aliyuncs.com'
export default {
	name: 'categoryManagement',
	components: {
		SmallClass,
		AddBigClass,
		SortBigClass
	},
	data () {
		return {
			name: '',
			bigClassData: [],
			classTreeData: [],
			smallTableData: [],
			defaultProps: {
				children: 'bigcategories'
			},
			categoryDefaultIcon: '',
			addCategoryVisible: false,
			selectBigClass: {},
			editBigClass: {},
			sortCategoryVisible: false,
			sortClassData: [],
			treeDefaultKey: '',
			timestamp: '',
			AuthorityList: {
				'01_0005_0001_00': false,
				'01_0005_0002_00': false,
				'01_0005_0003_00': false,
				'01_0005_0004_00': false,
				'01_0005_0005_00': false,
				'01_0005_0006_00': false,
				'01_0005_0007_00': false,
				'01_0005_0008_00': false,
				'01_0005_0013_00': false,
				'01_0005_0014_00': false,
				'01_0005_0015_00': false,
				'01_0005_0016_00': false
			},
			templateId: '',
			bigcategoryview: 0,
			multipleSelection: [],
			tipData: [],
			tipModal: false,
			searchKey: '',
			thirdCategoryEnabled: false
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '2-6')
		this.templateId = this.$route.query.id
		this.getAuthority('01_0005_0000_00')
		this.checkSmallCategory().then(res => {
			this.bigcategoryview = res.bigcategoryview
			this.refreshCategory()
			this.checkThirdCategory()
		})
	},
	watch: {
		classTreeData: {
			handler () {
				this.timestamp = new Date().getTime()
			},
			deep: true
		}
	},
	computed: {
		editBigClassTitle () {
			if (this.editBigClass.bc_name === undefined) {
				return '新增店铺级大类'
			} else {
				return `修改【${this.editBigClass.bc_name}】店铺级大类`
			}
		},
		bigClassImgUrl (src) {
			return src => {
				return `${QURL}${src}?timestamp=${this.timestamp}`
			}
		}
	},
	methods: {
		// 导入
		importExcel () {
			this.$refs.file.dispatchEvent(new MouseEvent('click'))
		},
		getFile (e) {
			this.uploadGoodsHandle()
			this.$refs.file.value = ''
		},
		uploadGoodsHandle () {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('file', this.$refs.file.files[0])
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.urlQIVShop}/baseCategory/importExcel`,
					data: formData
				}).then(res => {
					if (res.result) {
						this.tableData = res.data
						this.$message.success('导入成功！')
						this.refreshCategory()()
					} else {
						this.tipData = res.data
						this.tipModal = true
					}
				})
			})
		},
		tableSelect (val) {
			this.multipleSelection = val
		},
		goBack () {
			this.$router.push('/main/categoryLists')
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		classClickHandle (data) {
			this.getSmallCategory(data.bc_id).then(res => {
				data.smallCategory = res.data
				this.selectBigClass = data
				this.smallTableData = data.smallCategory
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		// 是否开启三级类别
		checkThirdCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/systemcenter/findallbasicinfo`
				}).then(res => {
					if (res.result) {
						let thirdcategoryview = res.data.thirdcategoryview || 0
						if (this.bigcategoryview !== 1) {
							thirdcategoryview = 0
						}
						this.thirdCategoryEnabled = thirdcategoryview === 1
					} else {
						this.thirdCategoryEnabled = false
					}
					resolve(this.thirdCategoryEnabled)
				}).catch(() => {
					this.thirdCategoryEnabled = false
					resolve(false)
				})
			})
		},
		// 获取大类
		refreshCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/getShopCategory`
			}).then(res => {
				if (res.result) {
					this.classTreeData = [{ id: '0', bc_name: '全部' }]
					this.classTreeData[0].bigcategories = res.data
					this.bigClassData = res.data
					// console.log(this.classTreeData)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getSmallCategory (id) {
			return new Promise((resolve, reject) => {
				let param = {
					pid: id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/getSmallCategory`,
					data: param
				}).then(res => {
					if (res.result) {
						resolve(res)
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		refreshSmallCategory () {
			let id = this.selectBigClass.bc_id
			this.getSmallCategory(id).then(res => {
				this.smallTableData = res.data
			})
		},
		// 大类搜索
		bigSearch () {
			let data = {
				name: this.searchKey
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/getShopCategory`,
				data: data
			}).then(res => {
				if (res.result) {
					let bigCategory = res.data.filter(item => {
						return ~item.bc_name.indexOf(this.searchKey)
					})
					this.bigClassData = bigCategory
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 小类搜索
		searchHandle (searchKey) {
			let id = this.selectBigClass.bc_id
			this.getSmallCategory(id).then(res => {
				let smallCategory = res.data.filter(item => {
					return ~item.name.indexOf(searchKey)
				})
				this.smallTableData = smallCategory
			})
		},
		addCategory () {
			this.editBigClass = {}
			this.addCategoryVisible = true
		},
		// 编辑
		tableEdit (row) {
			this.editBigClass = row
			this.addCategoryVisible = true
		},
		editCategory () {
			this.checkSelectClass().then((data) => {
				this.editBigClass = data
				this.addCategoryVisible = true
			})
		},
		sortCategory () {
			this.sortClassData = JSON.parse(JSON.stringify(this.classTreeData[0].bigcategories))
			this.sortCategoryVisible = true
		},
		// 无小类删除
		tableDelete (row) {
			this.$confirm(`是否删除店铺级大类【${row.bc_name}】?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				this.deleteBig(row)
			})
		},
		tableDeleteMulti () {
			if (this.multipleSelection.length === 0) {
				this.$alert('请选择一个店铺级大类!', '提示', {
					confirmButtonText: '确定'
				})
				return false
			}
			this.$confirm(`是否删除选中的店铺级大类?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let ids = this.multipleSelection.map(e => {
					return e.bc_id
				})
				let param = {
					ids: ids.join(','),
					type: 0
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/deleteShopCategory`,
					data: param
				}).then(res => {
					if (res.result) {
						this.$message({
							message: `删除店铺级大类成功!`,
							type: 'success'
						})
						this.refreshCategory()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		// 删除
		deleteCategory () {
			this.checkSelectClass().then((data) => {
				this.$confirm(`是否删除店铺级大类【${data.bc_name}】?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.deleteBig(data)
				})
			})
		},
		deleteBig (data) {
			let param = {
				ids: data.bc_id,
				type: 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/deleteShopCategory`,
				data: param
			}).then(res => {
				if (res.result) {
					this.$message({
						message: `删除店铺级大类【${data.bc_name}】成功!`,
						type: 'success'
					})
					this.refreshCategory()
					this.classClickHandle({ id: '0', bc_name: '全部' })
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 停用启用
		openCategory (openFlage) {
			let openText = openFlage ? '启用' : '停用'
			let openText2 = openFlage ? '显示' : '隐藏'
			let disableFlag = openFlage ? 0 : 1
			this.checkSelectClass().then((data) => {
				this.$confirm(`【${data.bc_name}】${openText}后,商城中将会${openText2}这个品类!`, '提示', {
					confirmButtonText: '是',
					cancelButtonText: '否',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					let param = {
						ids: data.bc_id,
						disabledFlag: disableFlag
					}
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlQIV}/shop/stopShopCategory`,
						data: param
					}).then(res => {
						if (res.result) {
							this.$message({
								message: `${openText}大类【${data.bc_name}】成功!`,
								type: 'success'
							})
							this.refreshCategory()
						} else {
							this.$message.error(res.msg)
						}
					})
				})
			})
		},
		tableOpen (openFlage) {
			if (this.multipleSelection.length === 0) {
				this.$alert('请选择一个店铺级大类!', '提示', {
					confirmButtonText: '确定'
				})
				return false
			}
			let openText = openFlage ? '启用' : '停用'
			let openText2 = openFlage ? '显示' : '隐藏'
			let disableFlag = openFlage ? 0 : 1
			this.$confirm(`店铺级大类${openText}后,商城中将会${openText2}这个品类!`, '提示', {
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let ids = this.multipleSelection.map(e => {
					return e.bc_id
				})
				let param = {
					ids: ids.join(','),
					disabledFlag: disableFlag
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/stopShopCategory`,
					data: param
				}).then(res => {
					if (res.result) {
						this.$message({
							message: `${openText}店铺级大类成功!`,
							type: 'success'
						})
						this.refreshCategory()
					} else {
						this.$message.error(res.msg)
					}
				})
			})
		},
		// 排序
		upHandle (index, row) {
			if (index === 0) {
				return false
			}
			let arr = this.bigClassData.concat()
			this.moveArr(arr, index, index - 1)
		},
		downHandle (index, row) {
			if (index === this.bigClassData.length - 1) {
				return false
			}
			let arr = this.bigClassData.concat()
			this.moveArr(arr, index, index + 1)
		},
		topHandle (index, row) {
			if (index === 0) {
				return false
			}
			let arr = this.bigClassData.concat()
			this.topArr(arr, index)
		},
		moveArr (arr, index1, index2) {
			arr[index1] = arr.splice(index2, 1, arr[index1])[0]
			this.sortHandle(arr)
		},
		topArr (arr, index) {
			let item = arr.splice(index, 1)[0]
			arr.unshift(item)
			this.sortHandle(arr)
		},
		sortHandle (arr) {
			let ids = arr.map(e => {
				return e.bc_id
			})
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/sortShopCategory`,
				data: ids
			}).then(res => {
				if (res.result) {
					this.$message({
						message: '一级分类排序成功!',
						type: 'success'
					})
					this.refreshCategory()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		checkSelectClass () {
			return new Promise(resolve => {
				let data = this.$refs.bigClassTree.getCurrentNode()
				if (data === null || data.bc_name === '全部') {
					this.$alert('请选择一个店铺级大类!', '提示', {
						confirmButtonText: '确定'
					})
				} else {
					resolve(data)
				}
			})
		},
		downloadFile (val) {
			let url = ''
			if (val === 1) {
				url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/business/qshop/basecategory/店铺级分类导入模板.xlsx?timeStamp=' + new Date().getTime()
			} else {
				url = 'https://fxscms.oss-cn-beijing.aliyuncs.com/sharego/business/qshop/basecategory/basecategory/店铺级分类导入模板.xlsx?timeStamp=' + new Date().getTime()
			}
			window.location.href = url
		}
	}
}
</script>
<style lang="stylus" scoped>
@import '~$assets/stylus/varsty.styl'
.category-management {
	overflow: hidden;
	display:flex;
	flex-direction: column;
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin-left: 0;
		width: 120px;
		height: 32px;
		display: flex;
		align-items: center;
		justify-content: center
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
	.fx-header {
		.header-p {
			float: left;
			display: inline-block;
			line-height: 75px;
			padding-right: 20px;
			i {
				border-radius: 50%;
				border: 1px solid #2c3e50;
				cursor: pointer;
			}
		}
		.header-btn-box{
			display :flex;
			flex-direction :row;
			align-items :center;
			height :100%;
			justify-content: flex-end;
		}
	}
	.management-header {
		height:50px;
		line-height:50px;
		text-align:left
		font-size: 16px;
		.back-btn {
			display:inline-block
			height:20px
			width:20px
			background-image:url('~images/icon/back-btn-icon.png')
			background-repeat:no-repeat
			background-position: center
			background-size: cover
			position: relative;
			top: 4px;
			margin: 0 10px;
		}
	}
	.management-container {
		margin-top :10px
		margin-bottom :10px
		flex:1;
		overflow: hidden
		.btn-style {
			width:80px
		}
		.big-class-wrap,.small-class-wrap {
			border:1px solid #eee;
			overflow:hidden;
			height: 100%;
		}
		.big-class-wrap {
			margin:0 5px 20px 0px;
			display: flex;
			flex-direction: column;
			margin-bottom: 0;
			.big-class-header {
				height: 40px;
				line-height: 40px;
				border-bottom: 1px solid #eee;
				text-align: left;
				padding-left: 20px;
				position:relative
				&::before {
					content: ''
					position:absolute
					height:20px
					width:3px
					background:$fxDefaultColor
					top: 9px;
					left: 10px;
				}
			}
			.big-class-btn-box {
				margin:10px 0
				.big-class-btn-row1 {
					margin-left: 20px
					margin-bottom:5px
					display :flex;
					flex-direction :row;
					align-items: center;
				}
				.big-class-btn-row {
					margin-left: 20px
					margin-bottom:5px
					text-align :left
				}
				.small-class-search-box {
					float:right
					width:200px
					display:flex
					flex-direction:row
					.search-btn {
						height:28px
						border-top-left-radius:0px !important
						border-bottom-left-radius:0px !important
					}
				}
			}
			.big-class-tree-box {
				overflow:auto
				flex: 1;
			}
			.custom-tree-node {
				width:100%
				text-align:left
				position:relative
			}
			.category-icon-img {
				height: 16px;
				width: 16px;
				display: inline-block;
				margin-right: 10px;
				vertical-align: middle;
			}
			.class-disabled-icon {
				border:1px solid $fxRed
				color:$fxRed
				margin-left: 5px;
				padding:2px
				position:absolute
				top:-4px
				right:60px
			}
			.class-homepage-icon{
				border:1px solid $fxRed
				color:$fxRed
				margin-left: 5px;
				padding:2px
				position:absolute
				top:-4px
				right:110px
			}
		}
		.small-class-wrap {
			margin:0 0px 20px 5px;
			margin-bottom: 0;
		}
	}
}
</style>
<style lang="stylus">
.el-dialog__header{
	text-align :left
	.el-dialog__headerbtn{
		right :10px
	}
}
.sort-class-dialog {
	height:75%
	display:flex;
	flex-direction: column
	overflow:auto
	.el-dialog__body {
		flex:1
		overflow:auto
		padding: 10px 20px 20px 20px;
	}
}
</style>
